import { Injectable, Inject, EventEmitter } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';

import { IErrorHandler } from '../dataModels/contracts/IErrorHandler';
import { ResourceService } from '../services/resource.service';
import { Configuration } from '../configurations/shared.config';

@Injectable()
export class ProfilePictureService {

    private _errorHandler: IErrorHandler;

    constructor(private _http: Http, @Inject("IErrorHandler") handler: IErrorHandler, private _resourceService: ResourceService) {

        this._errorHandler = handler;

    }

    //Delete Picture by Id
    async deletePictureById(pictureId: number): Promise<any> {

        var response = await this._http.delete(Configuration.urls.webApiEndpoint + Configuration.urls.pictureById + pictureId).toPromise()
            .catch(error => {
                this._errorHandler.Handle(
                    this._resourceService.Localize(Configuration.resources.sharedResourceName, Configuration.messages.defaultErrorMessage));
            });

        return response;
    }

}



// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/services/profile-picture.service.ts